export const USER_DESIG = {
    Admin: 0,
    AttdMD: 1,
    RefMD: 2,
    Photographer: 3,
    User: 4,
    ReadOnly: 5,
    ADUser: 6,
    RCSiteUser: 7,
    Invalid: 8,
    Device: 9,
    Reviewer: 10,
    ViewOnly: 11
}

export const PATIENT_TIMESPAN = {
    today: "Today's Patients",
    thisWeek: "This Week's Patients",
    thisMonth: "This Month's Patients",
    thisYear: "This Year's Patients",
    all: "All Patients"
}

export const PATIENT_TIMESPANS = [
    PATIENT_TIMESPAN.today,
    PATIENT_TIMESPAN.thisWeek,
    PATIENT_TIMESPAN.thisMonth,
    PATIENT_TIMESPAN.thisYear,
    PATIENT_TIMESPAN.all
]

export const CHNG_PSWD = [
    { value: false, text: "False" },
    { value: true, text: "True" }
]

export const CHNG_PSWD_NXT_LOGIN = [
    { value: false, text: "False" },
    { value: true, text: "True" }
]

export const USER_STATUS = [
    { value: true, text: "Active" },
    { value: false, text: "Inactive" }
]

export const USER_DESIGN_ADD = [
    {value: "Admin", text: "Admin"},
    {value: "AttdMD", text: "Attending Physician"},
    {value: "RefMD", text: "Referring Physician"},
    {value: "Photographer", text: "Photographer"},
    {value: "User", text: "User"},
    {value: "ReadOnly", text: "ReadOnly"},
    {value: "RCSiteUser", text: "RCSiteUser"},
    {value: "ViewOnly", text: "ViewOnly"},
]

export const PHYSICIAN_LEVEL = [
    {value: "ATTDMD", text: "Attending Physician"},
    {value: "REFMD", text: "Referring Physician"}
]

export const ISSELECTED = [
    {value: 1, text: "Active"},
    {value: 0, text: "Inactive"}
]

export const SEARCH_BY = {
    Keyword: 0,
    Advanced: 1,
    User: 2,
    Date: 3,
    DateIntervals: 4,
    EMRLink: 5,
    All: 6
}

export const GENDERS = [
    { value: "M", text: "Male" },
    { value: "F", text: "Female" },
    { value: "U", text: "Unknown" }
]

export const PAGE_SIZE = [
    { value: null, text: "Default"},
    { value: 25, text: "25" },
    { value: 50, text: "50" },
    { value: 100, text: "100" }
]

export const PATIENT_DATE_SETTING = [
    { value: "day", text: "Today's Patients" },
    { value: "week", text: "This Week's Patients" },
    { value: "month", text: "This Month's Patients" },
    { value: "year", text: "This Year's Patients" },
    { value: "all", text: "All Patients" }
]

export const PATIENT_DATE_SETTING_USERPREF = [
    { value: null, text: "Default"},
    { value: "day", text: "Today's Patients" },
    { value: "week", text: "This Week's Patients" },
    { value: "month", text: "This Month's Patients" },
    { value: "year", text: "This Year's Patients" },
    { value: "all", text: "All Patients" }
]

export const AUTO_REFRESH = [
    { value: null, text: "Default"},
    { value: 1, text: "ON" },
    { value: 0, text: "OFF" }
]

export const FULL_SCREEN = [
    { value: null, text: "Default"},
    { value: 1, text: "ON" },
    { value: 0, text: "OFF" }
]

export const DEFAULT_HVF_ORDER = [
    { value: null, text: "Default"},
    {value: 1, text: "OD | OS"},
    {value: 2, text: "OS | OD"},
]

export const DEFAULT_CIRRUS_VIEW = [
    { value: null, text: "Default"},
    {value: 3, text: "Black/White"},
    {value: 4, text: "Color"},
]

export const EXAM_LOCATION = [
    { value: "C:/Desktop", text: "C:/Desktop" },
    { text: "Browse" }
]

export const EYES = [
    { value: "OD", text: "OD" },
    { value: "OS", text: "OS" },
    { value: "OU", text: "OU" },
    { value: "U", text: "U" },
]

export const EyeTypes = {
    OD: "OD",
    OS: "OS",
    OU: "OU",
    U: "U"
}

export const PATIENT_STATUS = [
    { value: "1", text: "Validated", icon: "fas fa-check", tooltip: "" },
    { value: "0", text: "Locked", icon: "fas fa-lock", tooltip: "" },
    { value: "2", text: "Flag", icon: "fas fa-exclamation-triangle", tooltip: "" },
    { value: "4", text: "Normal", icon: "", tooltip: "" }
]

export const PLAY_RATES = [
    { value: "0.1", text: "0.1 sec" },
    { value: "0.2", text: "0.2 sec" },
    { value: "0.3", text: "0.3 sec" },
    { value: "0.4", text: "0.4 sec" },
    { value: "0.5", text: "0.5 sec" },
    { value: "1", text: "1 sec" },
    { value: "3", text: "3 sec" },
    { value: "5", text: "5 sec" },
    { value: "10", text: "10 sec" },
]

export const ANNOTATION_COLORS = {
    White: "#fff",
    LightGray: "#D9D9D9",
    Black: "#000000",
    DarkGray: "#595959",
    Brown: "#993300",
    LightBrown: "#DAAA94",
    Red: "#ff0d00",
    LightRed: "#FF9999",
    Orange: "#FF6600",
    LightOrange: "#FFB38A",
    Yellow: "#ffff00",
    LightYellow: "#ffff99",
    Green: "#1b992e",
    LightGreen: "#A9D18E",
    Blue: "#3800ff",
    LightBlue: "#BDD7EE",
    Purple: "#7030A0",
    LightPurple: "#C198E0"
}

export const ANNOTATION_MODES = {
    // annotation selection modes (none behaves like select)
    None: 0,
    Select: 1,
    Delete: 2,

    // canvas manipulation modes
    Magnify: 3,

    // non-measurement annotations
    Arrow: 5,
    Text: 6,
    Redact: 7,
    FreeHandLine: 8,
    ContinuousDraw: 23,
    Angle: 9,
    Outline: 26,

    // measurement annotations
    LengthLine: 10,
    Area: 11,
    CupToDisc: 12,
    FreeHandArea: 13,
    CountingGrid: 14,
    PDT: 15,
    ETDRSGrid: 16,
    StandardCircles1: 17, // C0, C1, C2
    StandardCircles2: 18, // C3, C4
    DrusenCircles1: 19, // C-0, C-1, C-2
    DrusenCircles2: 20, // I-2, O-2
    DrusenCircles3: 21, // DA / 2
    DrusenCircles4: 22, // DA
    Rectangle: 24,

    // DeepDee annotation
    DeepDeeInfo: 25,

    // Color fill mode
    ShapeFill: 27
}

export function addMode(mode) {
    return mode > ANNOTATION_MODES.Magnify && mode != ANNOTATION_MODES.ShapeFill;
}

export function editMode(mode) {
    return mode < ANNOTATION_MODES.Magnify
}

export function deleteMode(mode) {
    return mode == ANNOTATION_MODES.Delete;
}

export function magnifyMode(mode) {
    return mode == ANNOTATION_MODES.Magnify;
}

export function shapeFillMode(mode) {
    return mode == ANNOTATION_MODES.ShapeFill;
}

export const POINTER_CLASSES = {
    pointer: "annotation-hover-pointer",
    text: "annotation-hover-text",
    neswResize: "annotation-hover-nesw-resize",
    nwseResize: "annotation-hover-nwse-resize",
    nsResize: "annotation-hover-ns-resize",
    ewResize: "annotation-hover-ew-resize"
}

export const GRAYSCALE_MODES = {
    None: "",
    REC709: "REC709",
    Red: "Red",
    Green: "Green",
    Blue: "Blue",
}

export const Manufacturers = {
    Unknown: "",
    Zeiss: "zeiss",
    Heidelberg: "heidelberg",
    Optovue: "optovue"
}

export const ScanTypes = {
    Unknown: "",
    Volume: "volume",
    Circle: "circle",
    Star: "star",
    Raster: "raster",
    Section: "section",
    RadialCircle: "radial circles"
}

export const SeriesTypes = {
    Unknown: "",
    Macula: "macula",
    OpticDisc: "opticDisc",
    AnteriorSegment: "anteriorSegment"
}

export const ImageFormats = {
    Color: 0,
    Grayscale: 1,
    Grayscale16: 2
}

export const SliceLayerTypes = {
    Ilm: 0,
    Rnfl: 1,
    Ipl: 2,
    Opl: 3,
    Rpe: 4,
    RpeFit: 5,
    Bm: 6,
}

export const EyeMarkers = {
    None: 0,
    SI: 1,
    IS: 2,
    TN: 3,
    NT: 4
}

export const OCTBrowserType = {
    Unknown: 0,
    Spectralis: 1,
    Cirrus: 2,
    Raster: 3
}

export const AdminPanelTabs = {
    DashBoard: 1,
    Reports: 2
}

export const ReportTypes = {
    User: 1,
    Exam: 2,
    Device: 3
}

export const GROUP_BY = {
    none: 0,
    exDateTime: 1,
    exDevProc: 2,
    phySrNo: 3,
    exDictated: 4,
    exIsStudy: 5,
    pathNote: 6,
    devType: 7,
    devLocation: 8
}

export const UserActivities =  [
    { value: 0, text: "User Login"},
    { value: 1, text: "User Logout" }, 
    { value: 2, text: "User Password Change" },
    { value: 4, text: "Patient View" },
    { value: 5, text: "Patient Add" },
    { value: 6, text: "Patient Edit" },
    { value: 7, text: "Patient Remove" },
    { value: 8, text: "Patient Lock" },
    { value: 9, text: "Patient Merge" },
    { value: 10, text: "Exam View" },
    { value: 11, text: "Exam Add" },
    { value: 12, text: "Exam Edit" },
    { value: 13, text: "Exam Remove" },
    { value: 14, text: "Exam Lock" },
    { value: 15, text: "Exam Merge" },
    { value: 16, text: "Exam Zipped" },
    { value: 17, text: "Image Add" },
    { value: 18, text: "Image View" },
    { value: 19, text: "Image Annotate" },
    { value: 20, text: "Image Annotate As New" },
    { value: 21, text: "Image Remove" },
    { value: 22, text: "Image Download" },
    { value: 23, text: "Image Moved" },
    { value: 24, text: "Image Edited" },
]

export const BoolAndEither = [
    { value: null, text: "Either"},
    { value: true, text: "Yes" }, 
    { value: false, text: "No" }
]

export const Directions = {
    Unknown: 0,
    Vertical: 1,
    Horizontal: 2
}

export const DEFAULT_PATIENT_LISTING = [
    { value: 1, text: "Today" },
    { value: 2, text: "Week" },
    { value: 3, text: "Month" },
    { value: 4, text: "Year" },
    { value: 5, text: "All" }
]

export const DEFAULT_HVF = [
    {value: false, text: "OD | OS"},
    {value: true, text: "OS | OD"},
]

export const DEFAULT_MACULAR_CUBE_SCAN_RATIO = [
    {value: "original", text: "Original"},
    {value: "stretch", text: "Stretch"},
]

export const DEFAULT_MACULAR_CUBE_SCAN_RATIO_USER_PREF = [
    {value: "default", text: "Default"},
    {value: "original", text: "Original"},
    {value: "stretch", text: "Stretch"},
]


export const TRUE_OR_FALSE = [
    {value: true, text: "True"},
    {value: false, text: "False"}
]

export const ENABLE_OR_DISABLE = [
    {value: true, text: "Enable"},
    {value: false, text: "Disable"}
]
export const SELECT_ALL = "Select/Deselect All";

export const TEXT_SIZES = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];

export const THUMBNAIL_DROPDOWN = {
    currentPrevious: 1,
    currentBaseline: 2
}

export const PRELOAD_OPTIONS = {
    preLoadAll: "PreLoadAll",
    preLoadNone: "PreLoadNone",
    preLoad2Steps: "PreLoad2Steps"
}

export const SINGLE_OR_MULTI = [
    {value: "singleView", text: "Single View"},
    {value: "multiView", text: "Multi View"}
]

export const SINGLE_OR_MULTI_USERPREF = [
    {value: null, text: "Default"},
    {value: "singleView", text: "Single View"},
    {value: "multiView", text: "Multi View"}
]

export const MULTIVIEW_COLLAPSE_BY_DEFAULT = [
    { value: null, text: "Default"},
    { value: 1, text: "Yes" },
    { value: 0, text: "No" }
]

export const EYES_ORDER_TYPE = {
    OD_OS: 1,
    OS_OD: 2
}

export const DEFAULT_VIEW_TYPE = {
    singleView: "singleView",
    multiView: "multiView"
}

export const COLOR_TYPE = {
    darkblue: 1,
    white: 2,
    blackWhite: 3,
    color: 4,
    gray: 5,
    green: 6
}

export const THUMBNAIL_ANNOTATION_TYPE = {
    spectralisCircle: 1,
    spectralisVolume: 2,
    spectralisRadial: 3,
    spectralisRadialSCN: 4,
    cirrusReferenceMacular: 5,
    cirrusReferenceRaster: 6,
    spectralisSection: 7,
    spectralisRadialCircle: 8,
    cirrusReferenceOpticDisc: 9
}

export const VALID_IMG_TYPES = [
    "IMAGE",
    "IMAGE-SLO",
    "IMAGE-MNTG",
    "IMAGE-SCN",
    "DICOM-ZEISS",
    "DICOM-OPTOS",
    "DICOM-PRESENTATION",
    "DICOM-UNKNOWN"
]

export const DEEP_DEE_COLORS = 
    ["#563dfc", 
    "#9e99c2",
    "#84d4db", 
    "#e7ff0f", 
    "#ffa640", 
    "#cc6d00",
    "#ff0800" 
];

export const SHOW_BACKGROUND_BOX = 
    [
        { value: true, text: "Yes" },
        { value: false, text: "No" }
];

export const DEV_CONFIG_TYPES = 
[
    {value: 1, text: "Reorder"},
    {value: 2, text: "Calibration"},
    {value: 3, text: "Montage/OverLay"}    
];

export const DEV_CONFIG_XML_VALUES = 
[
    {value: 1, text: "REORDER"},
    {value: 2, text: "magVal"},
    {value: 3, text: "I2K"}    
];

export const DEVICE_HISTORY_SORTBY = 
{
    None: 0,
    Username: 1,
    TmStamp: 2,
    OldValues: 3,
    NewValues: 4
};

export const DEVICE_HISTORY_EDITABLE_FIELDS = 
[
    "devtype",
    "devname",
    "devproc",
    "devdescrition",
    "isactive",
    "ignorerotation",
    "orderbylaterality",
    "defaultzoomfactor",
    "devconfig"
];